import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FlagOutlineIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.3334 2.66732H4.00008V1.33398H2.66675V14.6673H4.00008V9.33398H13.3334L12.0001 6.00065L13.3334 2.66732ZM10.7601 6.49398L11.3601 8.00065H4.00008V4.00065H11.3667L10.7667 5.50732L10.5667 6.00065L10.7601 6.49398Z" />
  </Icon>
);

export default memo(FlagOutlineIcon);
